import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { AuthLayout } from "@/components/Brand";
import { Field, FormError, SubmitButton } from "@/components/common";
import { useAuth, homePathFor } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { t } from "@/i18n";

export function LoginForm({ onSuccess, forgotHref = "/forgot-password", testPrefix = "login" }) {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const me = await login(email, password);
      onSuccess(me);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-5" data-testid={`${testPrefix}-form`}>
      <FormError message={error} />
      <Field label={t("auth.email")} htmlFor={`${testPrefix}-email`}>
        <Input id={`${testPrefix}-email`} type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid={`${testPrefix}-email-input`} className="h-11" />
      </Field>
      <Field label={t("auth.password")} htmlFor={`${testPrefix}-password`}>
        <Input id={`${testPrefix}-password`} type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid={`${testPrefix}-password-input`} className="h-11" />
      </Field>
      <div className="flex justify-end">
        <Link to={forgotHref} className="text-sm font-medium text-teal-700 hover:text-teal-900" data-testid={`${testPrefix}-forgot-link`}>{t("auth.forgotLink")}</Link>
      </div>
      <SubmitButton busy={busy} className="h-11 w-full" data-testid={`${testPrefix}-submit-button`}>{t("auth.loginButton")}</SubmitButton>
    </form>
  );
}

export default function Login() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next");
  return (
    <AuthLayout title={t("auth.loginTitle")} subtitle={t("auth.loginSubtitle")}>
      <LoginForm onSuccess={(me) => navigate(next && next.startsWith("/") ? next : homePathFor(me), { replace: true })} />
    </AuthLayout>
  );
}
